import { RouteAgreementFormModel } from "../types/RouteAgreementFormModel";
import { RouteAgreementForForm } from "../types/types";
import { transformRouteAgreementToArticleForm } from "../types/ArticlesFormModel";
import { transformRouteAgreementToConditionsForm } from "../types/ConditionsFormModel";
import { transformRouteAgreementToRoutesForm } from "../types/RoutesFormModel";
import { transformRouteAgreementToNotesForm } from "../types/NotesFormModel";
import { transformRouteAgreementToMatrixForm } from "../types/MatrixFormModel";

export const transformRouteAgreementToForm = (
  routeAgreement: RouteAgreementForForm
): RouteAgreementFormModel => {
  return {
    conditions: transformRouteAgreementToConditionsForm(routeAgreement),
    routes: transformRouteAgreementToRoutesForm(routeAgreement),
    articles: transformRouteAgreementToArticleForm(routeAgreement),
    notes: transformRouteAgreementToNotesForm(routeAgreement),
    matrix: transformRouteAgreementToMatrixForm(routeAgreement),
  };
};
